import { Form as FormikForm } from "formik"

import {
    L2RButton,
    FormikDatePicker,
    FormikSelect,
    Skeleton,
    TagsAutocomplete as L2RTagsAutocomplete,
    Typography,
    styled,
    styledForMobile,
    MenuItem as UiMenuItem,
    FormikTextField,
} from "@l2r-front/l2r-ui"

export const FormContent = styledForMobile("div")(({ theme, isMobile }) => ({
    alignItems: "center",
    display: "flex",
    flex: "1 1 0",
    flexDirection: isMobile ? "column" : "row",
    gap: theme.spacing(6),
    paddingTop: theme.spacing(2),
}))

export const FieldsWrapper = styledForMobile("div")(({ theme, isMobile }) => ({
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(6),
    justifyContent: "center",
    flex: "0 0 auto",
    width: isMobile ? "100%" : `calc(100% - ${theme.spacing(4)})`,
}))

export const Select = styled(FormikSelect)(({ theme }) => ({
    alignItems: "center",
    display: "flex",
    height: "auto",
    maxWidth: "100%",
    width: "100%",
    "& .MuiOutlinedInput-input": {
        display: "flex",
        gap: theme.spacing(4),
    }
}))

export const TextField = styled(FormikTextField)(() => ({
    width: "100%",
}))

export const DatePicker = styled(FormikDatePicker)(() => ({
    width: "100%",
}))

export const SubmitButton = styled(L2RButton)(({ theme }) => ({
    marginLeft: theme.spacing(2),
    textTransform: "capitalize",
}))

export const FormSkeleton = styled(Skeleton)(() => ({
    transform: "none",
}))

export const ErrorMessage = styled(Typography)(({ theme }) => ({
    color: theme.palette["error"].main,
}))

export const TagsAutocomplete = styled(L2RTagsAutocomplete)(() => ({
}))

export const Form = styled(FormikForm)(() => ({
    height: "100%",
    display: "flex",
    flexDirection: "column",
    width: "100%",
}))

export const MenuItem = styled(UiMenuItem)(({ theme }) => ({
    alignItems: "center",
    display: "flex",
    gap: theme.spacing(4),
}))

export const Color = styled("span", { shouldForwardProp: (prop) => prop !== "color" })(({ color }) => ({
    backgroundColor: color,
    borderRadius: 4,
    display: "inline-block",
    height: 24,
    marginRight: 0,
    width: 24,
}))